import React from "react";
import SeasonDropdown from "../search/SeasonDropdown";

const ProfileTabs = ({
  tabs,
  activeTab,
  setActiveTab,
  isMobile,
  showEditButton,
  editButton,
  seasonOptions,
  selectedSeasonId,
  setSelectedSeasonId,
}) => {
  if (isMobile) { 
    return (
      <div className="border-b bg-white sticky top-0 z-20">
        <div className="px-4 flex flex-col py-3">
          {/* Tabs Row */}
          <div className="flex items-center overflow-x-auto no-scrollbar mb-3">
            <div className="flex gap-1 bg-[#F3F4F6]/50 p-1.5 rounded-xl border border-[#D6DBEA]">
              {tabs.map((tab) => {
                const Icon = tab.Icon;
                const isActive = activeTab === tab.id;
                
                return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-2 px-4 rounded-lg font-medium relative flex items-center gap-2 transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? "bg-white text-[#0B0B0B] shadow-sm"
                      : "text-[#6B7280]"
                  }`}
                >
                  {Icon && <Icon color={isActive ? "#0B0B0B" : "#6B7280"} />}
                  {tab.label}
                </button>
              )})}
            </div>
          </div>
          
          {/* Dropdown and Edit Button Row */}
          {(activeTab === "statistics" && seasonOptions) || showEditButton ? (
            <div className="flex items-center gap-2">
              {activeTab === "statistics" && seasonOptions && (
                <div className="flex-1">
                  <SeasonDropdown
                    options={seasonOptions}
                    selectedId={selectedSeasonId}
                    onChange={setSelectedSeasonId}
                    id="season-select-mobile-tabs"
                    compact={true}
                    isMobile={true}
                  />
                </div>
              )}
              {showEditButton && editButton}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="border-b bg-white sticky top-0 z-20">
      <div className="w-full mx-auto px-4 md:px-10">
        <div className="flex justify-between items-center h-16">
          <div className="flex gap-1 bg-[#F3F4F6]/50 p-1.5 rounded-xl border border-[#D6DBEA]">
            {tabs.map((tab) => {
              const Icon = tab.Icon;
              const isActive = activeTab === tab.id;
              // Desktop: Active has bg, Inactive no bg. Text always dark-ish?
              // Existing: Active bg-[#F3F4F6], text black. Inactive text black/hover.
              // We'll use color #1E1E1E for both, maybe lighter for inactive?
              const color = isActive ? "#1E1E1E" : "#575757"; // #575757 is a common grey
              
              return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-2 px-4 rounded-lg font-medium relative flex items-center gap-2 transition-all duration-200 ${
                  isActive
                    ? "bg-white text-[#0B0B0B] shadow-sm"
                    : "text-[#6B7280] hover:text-gray-900"
                }`}
              >
                {Icon && <Icon color={isActive ? "#0B0B0B" : "#6B7280"} />}
                {tab.label}
              </button>
            )})}
          </div>
          
          <div className="flex items-center gap-3">
            {activeTab === "statistics" && seasonOptions && (
              <div className="w-auto">
                <SeasonDropdown
                  options={seasonOptions}
                  selectedId={selectedSeasonId}
                  onChange={setSelectedSeasonId}
                  id="season-select-desktop-tabs"
                />
              </div>
            )}
            {showEditButton && editButton}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileTabs;
